<template>
  <div class="main">
    <div class="main-left" :class="{'open':state == 'open','shrink':state == 'shrink'}">
      <img v-if="state == 'open'" class="switch" src="@/assets/img/shrink.png" @click="state = 'shrink'" />
      <img v-else class="switch" src="@/assets/img/open.png" @click="state = 'open'" />
      <template v-if="state == 'open'">
        <div class="userInfo">账号：{{userInfo.username}}</div>
        <div class="search">
          <el-form :model="form" label-width="1.5rem">
            <div class="form-row">
              <el-form-item label="日期">
                <div class="text">{{formatDate.substring(0,10)}}</div>
              </el-form-item>
            </div>
            <div class="form-row">
              <el-form-item label="生产单位">
                <el-select class="form_content" v-model="form.groupsId" placeholder="选择生产单位" @change="groupChange">
                  <el-option v-for="(item,index) in groupList" :value="item.id" :label="item.name" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <!-- <div class="form-row">
              <el-form-item label="生产指令">
                <el-input class="form_content" v-model="form.orderNo" placeholder="选择生产指令" readonly>
                  <el-button slot="append" @click="handleShowOrder">选</el-button>
                </el-input>
              </el-form-item>
            </div> -->
            <div class="form-row">
              <el-form-item label="">
                <div class="info_btn" @click="handleShowOrder">选择指令</div>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="info">
          <div class="sub-title">指令信息</div>
          <div class="box">
            <div class="row">
              <div class="label">型体：</div>
              <div class="content">{{info.order && info.order.customerStyle || '未选择生产指令'}}</div>
            </div>
            <div class="row">
              <div class="label">颜色：</div>
              <div class="content">{{info.order && info.order.colorCn || '未选择生产指令'}}</div>
            </div>
            <div class="row">
              <div class="label">数量：</div>
              <div class="content">{{info.order && info.order.orderQuantity + info.order.preReplenishQuantity || '未选择生产指令'}}</div>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="sub-title">生产状况</div>
          <div class="box">
            <div class="row">
              <div class="label" style="width:2.1rem;">订单今日交接</div>
              <div class="content">{{handOverInfo.orderDayFeedQty || 0}}<span class="unit">双</span></div>
            </div>
            <div class="row">
              <div class="label" style="width:2.1rem;">订单累计交接</div>
              <div class="content">{{handOverInfo.orderHandQty || 0}}<span class="unit">双</span></div>
            </div>
            <div class="row">
              <div class="label" style="width:2.1rem;">今日累计交接</div>
              <div class="content">{{handOverInfo.dayHandQty || 0}}<span class="unit">双</span></div>
            </div>
            <div class="row">
              <div class="label" style="width:2.1rem;">本月累计交接</div>
              <div class="content">{{handOverInfo.monthHandQty || 0}}<span class="unit">双</span></div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="main-content">
      <div class="title">成品交接</div>
      <div class="operate">
        <template v-if="form.groupsId && form.orderNo">
          <div class="clear" @click="clearOrder">清空生产指令</div>
          <div class="clear" @click="delOrder">删除当前生产指令</div>
        </template>
        <div class="logout" @click="logOut">退出</div>
      </div>
      <img v-if="!form.groupsId || !form.orderNo" class="default" src="@/assets/img/default.png" />
      <template v-else>
        <div class="order-list">
          <div class="order-item" :class="{'current':item.order.orderNo==form.orderNo}" v-for="(item,index) in selectOrderList" :key="index" @click="handleOrderSelect(item)">
            {{item.order.orderNo}}
          </div>
        </div>
        <div class="count">
          <div class="item" v-if="currentSize.id">当前尺码已交接&#x3000;<span class="num">{{currentSize.handQty}}</span>双</div>
          <div class="item" v-if="currentSize.id">当前尺码可交接&#x3000;<span class="num">{{currentSize.feedQty - currentSize.fqcNgQty - currentSize.handQty}}</span>双</div>
        </div>
        <div class="pane">
          <div class="box">
            <div class="pass-list">
              <div class="item" :class="{'disabled':item.orderQuantity + item.preReplenishQuantity == 0 || item.feedQty - item.fqcNgQty - item.handQty <= 0, 'select': currentSize.id == item.id}" v-for="item in info.sizeList" :key="item.id" @click="sizeSelect(item)">
                <div>{{item.size}} </div>
                <div class="qty">{{item.qty||0}}</div>
              </div>
              <div class="item disabled" v-for="item in 40" :key="item"></div>
            </div>
          </div>
          <div class="box">
            <div class="num-list">
              <div class="item" v-for="item in numList" :key="item.id" @click="numAdd(item)">
                <div>{{item.label}}</div>
              </div>
              <div class="item clear" @click="clear">清除</div>
            </div>
          </div>
          <div class="submit-btn" @click="submit">交接</div>
        </div>
      </template>
    </div>
    <div class="order-select" v-if="showOrder">
      <div class="order-search">
        <el-form :model="orderSearchForm" label-width="1.2rem" inline>
          <el-form-item label="是否出货">
            <el-select class="form_content" v-model="orderSearchForm.searchCondition.isDelivery" placeholder="是否出货" style="width:3rem;">
              <el-option :value="true" label="已出货"></el-option>
              <el-option :value="false" label="未出货"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指令号">
            <el-input class="form_content" v-model="orderSearchForm.searchCondition.orderNo" placeholder="多指令号 , 隔开" style="width:3rem;"></el-input>
          </el-form-item>
          <el-form-item label="客户型体">
            <el-input class="form_content" v-model="orderSearchForm.searchCondition.customerStyle" placeholder="客户型体" style="width:3rem;"></el-input>
          </el-form-item>
          <el-form-item label="工厂型体">
            <el-input class="form_content" v-model="orderSearchForm.searchCondition.factoryStyle" placeholder="工厂型体" style="width:3rem;"></el-input>
          </el-form-item>
          <div>
            <el-form-item label=" ">
              <div class="info_btn" @click="orderSearch">搜索</div>
              <div class="info_btn" @click="showOrder = false">返回</div>
              <div class="primary_btn" @click="orderSearchAll">确认选择</div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-table height="100"
        ref="orderTable"
        :data="orderList" border
        highlight-current-row
        :header-cell-style="{backgroundColor:'#EDF1FF',fontWeight:'bold',color:'#101010'}"
        style="width: 100%;font-size: 0.16rem;" @row-click="rowClick" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55px" align="center" fixed="left"></el-table-column>
        <el-table-column label="客户" prop="customerName" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="指令号" prop="orderNo" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="订单数量" prop="orderQuantity" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="预补数量" prop="preReplenishQuantity" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="型体" prop="customerStyle" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="接单日期" prop="receiptDate" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.receiptDate?scope.row.receiptDate.substring(0,10):''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="工厂交期" prop="factoryDeliveryDate" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.factoryDeliveryDate?scope.row.factoryDeliveryDate.substring(0,10):''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="颜色" prop="colorCn" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="材质" prop="texture" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="楦头号" prop="shoeLast" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="orderSearchForm.current"
        :page-size="orderSearchForm.size"
        @current-change="currentChange"
        :total="orderTotal">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { logout } from '@/api/user'
import { groupList, orderPage, orderDetail, getHandOverInfo, handOver } from '@/api/api'

export default {
  data () {
    return {
      userInfo: {},
      form: {
        groupsId: '',
        orderNo: ''
      },
      orderSearchForm: {
        current: 1,
        size: 10,
        searchCondition: {
          isDelivery: false,
          isHandOver: false,
          isGroupBy: false,
          isPiece: false,
          isCancel: false,
          typeNameList: ['生产指令']
        }
      },
      orderTotal: 0,
      info: {},
      state: 'open',
      type: 'pass',
      showSize: false,
      showOrder: false,
      ngList: [],
      groupList: [],
      orderList: [],
      selectOrderList: [],
      sizeList: [],
      handOverInfo: {},
      numList: [
        {
          label: '1双',
          value: 1
        },
        {
          label: '2双',
          value: 2
        },
        {
          label: '3双',
          value: 3
        },
        {
          label: '4双',
          value: 4
        },
        {
          label: '5双',
          value: 5
        },
        {
          label: '10双',
          value: 10
        },
        {
          label: '20双',
          value: 20
        },
        {
          label: '30双',
          value: 30
        },
        {
          label: '40双',
          value: 40
        }
      ],
      currentSize: {}
    }
  },
  computed: {
    formatDate () {
      const date = new Date()
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      const hour = ('0' + date.getHours()).slice(-2)
      const minute = ('0' + date.getMinutes()).slice(-2)
      const second = ('0' + date.getSeconds()).slice(-2)
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    }
  },
  mounted () {
    this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    this.selectOrderList = localStorage.getItem('jj-selectOrderList') ? JSON.parse(localStorage.getItem('jj-selectOrderList')) : []
    this.form.groupsId = localStorage.getItem('groupsId') || (this.userInfo.staff && this.userInfo.staff.groupsId)
    if (this.selectOrderList.length) {
      this.handleOrderSelect(this.selectOrderList[0])
    }

    this.getGroupList()
    this.getOrderList()
    // 检测断网
    window.addEventListener('offline', () => {
      this.$message.warning('网络异常，请重新登录')
      this.$router.push({
        path: '/login'
      })
    })
  },
  methods: {
    // 获取生产单位
    getGroupList () {
      groupList({ deptName: '成型部', disabled: false }).then(res => {
        this.groupList = res.data
      })
    },
    // 获取生产指令列表（弹窗）
    getOrderList () {
      if (this.orderSearchForm.searchCondition.orderNo) {
        this.orderSearchForm.searchCondition.orderNoInList = this.orderSearchForm.searchCondition.orderNo.split(',')
      } else {
        this.orderSearchForm.searchCondition.orderNoInList = []
      }
      orderPage(this.orderSearchForm).then(res => {
        this.orderList = res.data
        this.orderTotal = res.total * 1
      })
    },
    getOrderInfo () {
      orderDetail(this.info.order.orderId).then(res => {
        if (res.code === 200) {
          res.data.sizeList.forEach(val => {
            this.$set(val, 'qty', 0)
          })
          const currentOrder = this.selectOrderList.find(a => a.order.orderId === this.info.order.orderId)
          if (!currentOrder.sizeList || !currentOrder.sizeList.length) {
            this.$set(currentOrder, 'sizeList', res.data.sizeList)
          } else {
            for (let i = 0; i < currentOrder.sizeList.length; i++) {
              const item = currentOrder.sizeList[i]
              currentOrder.sizeList[i] = {
                ...res.data.sizeList[i],
                qty: item.qty
              }
            }
          }

          this.info = currentOrder
          localStorage.setItem('jj-selectOrderList', JSON.stringify(this.selectOrderList))
          this.currentSize = currentOrder.sizeList.find(a => a.id === this.currentSize.id) || {}
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    getHandOverInfo () {
      const data = {
        date: this.formatDate,
        orderId: this.info.order.orderId,
        groupsId: this.form.groupsId
      }
      getHandOverInfo(data).then(res => {
        this.handOverInfo = res.data
      })
    },
    groupChange () {
      localStorage.setItem('groupsId', this.form.groupsId)
      this.getHandOverInfo()
    },
    reset () {
      this.form = {
        groupsId: '',
        orderNo: ''
      }
      this.info = {}
    },
    tabChange (type) {
      this.type = type
    },
    handleShowOrder () {
      if (!this.form.groupsId) {
        this.$message.warning('请先选择生产单位')
        return
      }
      this.orderSearch()
      this.showOrder = true
    },
    orderSearch () {
      this.currentChange(1)
    },
    rowClick (row) {
      this.$refs.orderTable.toggleRowSelection(row)
    },
    handleSelectionChange (list) {
      console.log(list)
      this.tableSelectList = list
    },
    orderSearchAll () {
      if (!this.tableSelectList || !this.tableSelectList.length) {
        this.$message.warning('请先选择指令')
        return
      }
      this.tableSelectList.forEach(row => {
        this.orderSelect(row)
      })
    },
    orderSelect (row) {
      if (!this.selectOrderList.find(a => a.order.id === row.id)) {
        this.selectOrderList.push({
          order: row,
          sizeList: []
        })
      }
      localStorage.setItem('jj-selectOrderList', JSON.stringify(this.selectOrderList))

      this.info = {
        order: row
      }
      this.form.orderNo = row.orderNo
      this.showOrder = false
      this.getOrderInfo()

      if (this.form.groupsId) {
        this.getHandOverInfo()
      }
    },
    handleOrderSelect (item) {
      if (this.form.orderNo === item.order.orderNo) {
        return
      }
      this.info = item
      this.form.orderNo = item.order.orderNo
      this.currentSize = {}
      this.getOrderInfo()
      if (this.form.groupsId) {
        this.getHandOverInfo()
      }
    },
    currentChange (current) {
      this.orderSearchForm.current = current
      this.getOrderList()
    },
    sizeSelect (item) {
      // if ((item.orderQuantity + item.preReplenishQuantity === 0) || (item.feedQty - item.fqcNgQty - item.handQty <= 0)) {
      //   return
      // }
      this.currentSize = item
      this.getOrderInfo()
    },
    numAdd (item) {
      if ((this.currentSize.orderQuantity + this.currentSize.preReplenishQuantity === 0) || (this.currentSize.feedQty - this.currentSize.fqcNgQty - this.currentSize.handQty <= 0)) {
        return
      }
      if (!this.currentSize.id) {
        this.$message.warning('请先选择尺码')
        return
      }
      console.log(this.currentSize)
      if (this.currentSize.qty) {
        this.currentSize.qty += item.value
      } else {
        this.currentSize.qty = item.value
      }
    },
    clear () {
      if (!this.currentSize.id) {
        this.$message.warning('请先选择尺码')
        return
      }
      this.$set(this.currentSize, 'qty', 0)
    },
    submit () {
      this.$confirm('交接后无法修改，确认提交吗？').then(() => {
        const data = []
        this.selectOrderList.forEach(val => {
          if (val.sizeList.some(a => a.qty)) {
            data.push({
              date: this.formatDate,
              manufactureId: val.order.id,
              orderId: val.order.orderId,
              groupsId: this.form.groupsId,
              handOverSizeList: val.sizeList.filter(a => a.qty).map((item, index) => {
                return {
                  size: item.size,
                  allQty: item.qty,
                  qty: item.qty,
                  sort: item.sort
                }
              })
            })
          }
        })

        const loading = this.$loading({
          lock: true,
          text: '提交中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        handOver(data).then(res => {
          loading.close()
          if (res.code === 200) {
            this.$message.success(res.msg)

            this.selectOrderList = this.selectOrderList.map(a => {
              return {
                order: a.order,
                sizeList: []
              }
            })
            localStorage.setItem('jj-selectOrderList', JSON.stringify(this.selectOrderList))
            this.getOrderInfo()
            this.getHandOverInfo()
          } else {
            this.$message.warning(res.msg)
          }
        }).catch(() => {
          loading.close()
        })
      })
    },
    // 清空生产指令
    clearOrder () {
      this.selectOrderList = []
      localStorage.setItem('jj-selectOrderList', [])
      this.currentSize = {}
      this.info = {}
      this.form.orderNo = ''
    },
    // 删除生产指令
    delOrder () {
      this.selectOrderList = this.selectOrderList.filter(a => a.order.orderNo !== this.form.orderNo)
      localStorage.setItem('jj-selectOrderList', JSON.stringify(this.selectOrderList))
      this.currentSize = {}
      if (this.selectOrderList.length) {
        this.info = this.selectOrderList[0]
        this.form.orderNo = this.selectOrderList[0].order.orderNo
        this.getOrderInfo()
        if (this.form.groupsId) {
          this.getHandOverInfo()
        }
      } else {
        this.info = {}
        this.form.orderNo = ''
      }
    },
    // 退出登录
    logOut () {
      logout().then(res => {
        localStorage.removeItem('token')
        this.$router.push({
          path: '/login'
        })
      })
    }
  }
}
</script>

<style lang="scss">
.main {
  display: flex;
  user-select: none;
  .main-left{
    position: relative;
    height: 100%;
    width: 5.66rem;
    background-color: rgba(255,255,255,1);
    box-shadow: 0rem 0rem 0.24rem 0rem rgba(0,0,0,0.3);
    padding-top: 0.65rem;
    box-sizing: border-box;
    transition: 0.1s;
    display: flex;
    flex-direction: column;
    &.shrink{
      width: 1rem;
    }
    .switch{
      position: absolute;
      top: 0.7rem;
      right: 0.35rem;
      width: 0.3rem;
      height: 0.3rem;
    }
    .title{
      text-align: center;
      color: rgba(255,0,0,1);
      font-size: 0.28rem;
      line-height: 0.4rem;
    }
    .sub-title{
      text-align: center;
      color: rgba(15,64,245,1);
      font-size: 0.24rem;
      line-height: 0.8rem;
    }
    .userInfo{
      padding-left: 0.9rem;
      font-size: 0.24rem;
    }
    .search{
      .el-form{
        width: 100%;
        box-sizing: border-box;
        margin-top: 0.3rem;
        .form-row{
          margin-bottom: 0.2rem;
          .el-form-item{
            margin: 0;
            input{
              height: 0.54rem;
              line-height: 0.54rem;
              font-size: 0.22rem;
              padding: 0 0.15rem;
            }
            .el-form-item__label,.el-form-item__content{
              line-height: 0.54rem;
              font-size: 0.22rem;
              padding: 0 0.12rem 0 0;
            }
            .el-input__icon{
              line-height: 0.54rem;
            }
            .primary_btn{
              cursor: pointer;
              display: inline-block;
              width: 2rem;
              height: 0.6rem;
              line-height: 0.6rem;
              text-align: center;
              border-radius: 0.05rem;
              background-color: #0F40F5;
              color: #fff;
              font-size: 0.24rem;
              &:hover,&:active{
                opacity: 0.8;
              }
            }
            .info_btn{
              cursor: pointer;
              display: inline-block;
              width: 2rem;
              height: 0.6rem;
              line-height: 0.58rem;
              text-align: center;
              border-radius: 0.05rem;
              background-color: #fff;
              color: #0F40F5;
              border: 0.01rem solid #0F40F5;
              font-size: 0.24rem;
              box-sizing: border-box;
              &:hover,&:active{
                opacity: 0.8;
              }
            }
            .text{
              font-size: 0.24rem;
              padding: 0 0.15rem;
            }
          }
          .form_content{
            display: flex;
            margin-right: 0.45rem;
            font-size: 0.14rem;
            width: auto;
            .el-form-item__content{
              flex: 1;
            }
            .el-input-group__append{
              padding: 0;
              width: auto;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.2rem;
              .el-button{
                padding: 0.12rem 0.2rem;
                margin: 0;
              }
            }
          }
        }
      }
    }
    .info{
      padding: 0 0.45rem;
      .box{
        border: 0.01rem solid rgba(15,64,245,1);
        border-radius: 0.1rem;
        padding: 0.2rem;
        .row{
          line-height: 0.5rem;
          display: flex;
          .label{
            color: rgba(0,0,0,1);
            font-size: 0.24rem;
          }
          .content{
            flex: 1;
            color: rgba(15,64,245,1);
            font-size: 0.24rem;
            .unit{
              float: right;
              color: rgba(0,0,0,1);
              margin-right: 0.2rem;
            }
          }
        }
      }
    }
  }
  .main-content{
    position: relative;
    flex: 1;
    width: 0;
    padding-top: 0.9rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title{
      position: absolute;
      top: 0.3rem;
      left: 0.3rem;
      font-size: 0.36rem;
      font-weight: bold;
    }
    .operate{
      position: absolute;
      top: 0.3rem;
      right: 0.3rem;
      display: flex;
      .clear{
        padding: 0 0.1rem;
        height: 0.5rem;
        border: 0.01rem solid rgba(15,64,245,1);
        color: rgba(15,64,245,1);
        font-size: 0.24rem;
        border-radius: 0.05rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-left: 0.2rem;
        &:active{
          opacity: 0.8;
        }
      }
      .logout{
        width: 1rem;
        height: 0.5rem;
        background-color: #f00;
        color: #fff;
        font-size: 0.24rem;
        border-radius: 0.05rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-left: 0.2rem;
        &:active{
          opacity: 0.8;
        }
      }
    }
    .default{
      width: 7.9rem;
      height: 7.9rem;
    }
    .order-list{
      display: flex;
      width: calc(100% - 1.75rem);
      align-items: center;
      margin-left: 1.3rem;
      margin-right: 1.45rem;
      margin-bottom: 0.2rem;
      overflow: auto;
      white-space: nowrap;
      .order-item{
        display: inline-block;
        cursor: pointer;
        font-size: 0.28rem;
        border: 0.01rem solid rgba(15,64,245,1);
        color: rgba(15,64,245,1);
        padding: 0.15rem 0.1rem;
        margin: 0.1rem;
        border-radius: 0.1rem;
        &.current{
          color: #fff;
          background-color: rgba(15,64,245,1);
        }
      }
    }
    .count{
      display: flex;
      margin-top: 0.4rem;
      height: 0.3rem;
      align-items: center;
      .item{
        font-size: 0.28rem;
        margin: 0 0.4rem;
        .num{
          color: rgba(255,0,0,1);
        }
      }
    }
    .pane{
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      justify-content: space-evenly;
      .box{
        margin-left: 1.3rem;
        margin-right: 1.45rem;
        width: calc(100% - 2.75rem);
        border: 0.01rem solid rgba(15,64,245,1);
        border-radius: 0.3rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        .pass-list{
          margin: 0.46rem 0.8rem;
          height: 4.1rem;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          overflow: hidden;
          .item{
            width: 2.2rem;
            height: 0.8rem;
            border: 0.01rem solid rgba(15,64,245,1);
            color: rgba(15,64,245,1);
            border-radius: 0.1rem;
            box-sizing: border-box;
            margin: 0.01rem;
            background-color: rgba(15,64,245,0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.42rem;
            cursor: pointer;
            &.select{
              background-color: rgba(15,64,245,1);
              color: #fff;
              div{
                &:nth-child(1){
                  border-right: 0.04rem solid #fff;
                }
              }
            }
            &.disabled{
              background-color: #DDD;
              border: 0.01rem solid #DDD;
              color: #666;
              div{
                &:nth-child(1){
                  border-right: 0.04rem solid #fff;
                }
                &.qty{
                  color: #666;
                }
              }
            }
            div{
              flex: 1;
              text-align: center;
              &:nth-child(1){
                border-right: 0.04rem solid rgba(15,64,245,1);
              }
              &.qty{
                color: #67C23A;
              }
            }
          }
        }
        .num-list{
          margin: 0.26rem 0.8rem;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          .item{
            width: 0.9rem;
            height: 0.9rem;
            background-color: rgba(15,64,245,0.1);
            border: 0.01rem solid rgba(15,64,245,1);
            color: rgba(15,64,245,1);
            margin: 0.1rem;
            border-radius: 0.1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.28rem;
            box-sizing: border-box;
            &:active{
              opacity: 0.8;
            }
            &.clear{
              background-color: #DDD;
              border: 0.01rem solid #DDD;
              color: #333;
            }
          }
        }
      }
      .submit-btn{
        width: 2rem;
        height: 0.8rem;
        font-size: 0.28rem;
        background-color: rgba(15,64,245,1);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.1rem;
        &:active{
          opacity: 0.8;
        }
      }
    }
  }
  .order-select{
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 10;
    padding: 0.6rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .order-search{
      width: 100%;
      .el-form{
        width: 100%;
        box-sizing: border-box;
        .el-form-item{
          margin: 0;
          margin-bottom: 0.3rem;
          input{
            height: 0.54rem;
            line-height: 0.54rem;
            font-size: 0.22rem;
            padding: 0 0.15rem;
          }
          .el-form-item__label,.el-form-item__content{
            line-height: 0.54rem;
            font-size: 0.22rem;
            padding: 0 0.12rem 0 0;
          }
          .el-input__icon{
            line-height: 0.54rem;
          }
          .primary_btn{
            cursor: pointer;
            display: inline-block;
            padding: 0 0.2rem;
            height: 0.6rem;
            line-height: 0.6rem;
            text-align: center;
            border-radius: 0.05rem;
            background-color: #0F40F5;
            color: #fff;
            font-size: 0.24rem;
            margin-right: 0.2rem;
            &:hover,&:active{
              opacity: 0.8;
            }
          }
          .info_btn{
            cursor: pointer;
            display: inline-block;
            padding: 0 0.2rem;
            height: 0.6rem;
            line-height: 0.58rem;
            text-align: center;
            border-radius: 0.05rem;
            background-color: #fff;
            color: #0F40F5;
            border: 0.01rem solid #0F40F5;
            font-size: 0.24rem;
            margin-right: 0.2rem;
            box-sizing: border-box;
            &:hover,&:active{
              opacity: 0.8;
            }
          }
        }
        .form_content{
          display: flex;
          margin-right: 0.45rem;
          font-size: 0.14rem;
          width: auto;
          .el-form-item__content{
            flex: 1;
          }
          .el-input-group__append{
            padding: 0;
            width: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.2rem;
            .el-button{
              padding: 0.12rem 0.2rem;
              margin: 0;
            }
          }
        }
      }
    }
    .el-table{
      font-size: 0.3rem;
      // colgroup {
      //   col:nth-child(2){
      //     width: 1.2rem !important;
      //   }
      //   col:nth-child(3){
      //     width: 1.2rem !important;
      //   }
      //   col:nth-child(4){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(5){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(6){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(7){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(8){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(9){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(10){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(11){
      //     width: 0.9rem !important;
      //   }
      // }
      tr.current-row {
        td.el-table__cell {
          background-color: #4E6EF2 !important;
          color: #fff;
          .pointer{
            color: #fff;
          }
        }
      }
      .pointer{
        cursor: pointer;
        color: #4E6EF2;
      }
      .cell{
        width: 100% !important;
        box-sizing: border-box;
        font-size: 0.24rem;
        line-height: 0.45rem;
        padding: 0 0.05rem;
      }
      .el-table__cell{
        padding: 0.12rem 0;
      }
    }
    .el-pagination{
      margin-top: 0.3rem;
      padding: 0;
    }
  }
}
</style>
